import { api, ApiError } from "@/api/api";
import { Prompt } from "@/api/prompts-types";
import { useQuery } from "@tanstack/react-query";

export function usePromptById(id?: string) {
  return useQuery<Prompt, ApiError>({
    queryKey: ["GET", "promptDetails", id],
    queryFn: () => api.prompts.promptId.get(id!),
    enabled: !!id,
  });
}
